import { render } from "./forgetPasswordTwo.vue?vue&type=template&id=5a348f43&scoped=true"
import script from "./forgetPasswordTwo.vue?vue&type=script&lang=js"
export * from "./forgetPasswordTwo.vue?vue&type=script&lang=js"

import "./forgetPasswordTwo.vue?vue&type=style&index=0&id=5a348f43&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a348f43"]])

export default __exports__